import { Trans, t } from '@lingui/macro';
import { Avatar, Box, Typography, Button, useToast } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Container, TruncateBox } from './styled';
export function PreviewClient(props) {
    const { clientId } = props;
    const { addToast } = useToast();
    const handleCopy = () => {
        navigator.clipboard
            .writeText(clientId)
            .then(() => {
            addToast({
                title: t({
                    message: 'Client id copied to clipboard!',
                    comment: 'Toast message when client id copied',
                }),
                appearance: 'success',
            });
        })
            .catch(() => {
            addToast({
                title: t({
                    message: 'Failed to copy client id to clipboard.',
                    comment: "Toast message when client id couldn't be copied",
                }),
                appearance: 'danger',
            });
        });
    };
    return (<Container>
      <Avatar size="lg" appearance="light" solid>
        <Falcon icon="fingerprint"/>
      </Avatar>
      <TruncateBox display="flex" flexDirection="column" width="100%">
        <Typography $fontSize="small" $truncate>
          <Trans comment="Preview client id - title">Client id</Trans>
        </Typography>
        <Typography $appearance="300" $fontSize="huge">
          {clientId}
        </Typography>
      </TruncateBox>
      <Box>
        <Button onClick={handleCopy} appearance="ghost">
          <Falcon icon="copy"/>
          <Trans comment="Button to copy client id">Copy</Trans>
        </Button>
      </Box>
    </Container>);
}
